import {Component, OnInit} from '@angular/core';
import {ProblemDetails} from '../../../app-common/data/problemDetails';
import {ForgotPasswordRequest} from '../../data/registerTrialRequest';
import {AuthService} from '../../services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppStateService, AppWindowState} from '../../../app-common/services/appState/app-state.service';


@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss', '../unauthorized.scss']
})
export class ForgotPasswordPageComponent implements OnInit {
  email: string = '';
  problemDetails: ProblemDetails<ForgotPasswordRequest>;

  constructor(private authService: AuthService,
              private appStateService: AppStateService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  sendEmail() {
    this.authService.sendPasswordResetEmail(this.email).then(() => {
      this.changeStateToLogin();
    }).catch(error => {
      if (error instanceof ProblemDetails) {
        this.problemDetails = error;
      }
    });
  }


  async changeStateToLogin() {
    this.appStateService.appWindowState = AppWindowState.Login;
    this.router.navigate(['login']);
  }

}
